export function accordion() {
    const $accordion = $(".accordion");
    const $accordionTitle = $accordion.find(".title");
    const $accordionContent = $accordion.find(".content-wrap");
    const $accordionBlock = $accordion.find(".accordion-block");
    $accordionBlock.each(function () {
        if ($(this).hasClass("active")) {
            $accordionBlock.removeClass("active");
            $accordionContent.slideUp(300);
            $(this).addClass("active");
            $(this).find(".content-wrap").slideDown(300);
        }
    });
    $accordionTitle.on("click", function () {
        const $currentAccordionBlock = $(this).parent(".accordion-block");
        const content = $currentAccordionBlock.find(".content-wrap");
        if ($currentAccordionBlock.hasClass("active")) {
            $currentAccordionBlock.removeClass("active");
            content.slideUp(300);
        } else {
            $accordionBlock.removeClass("active");
            $accordionContent.slideUp(300);
            $currentAccordionBlock.addClass("active");
            content.slideDown(300);
        }

    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js